import React, { useContext } from "react";
import { Button, Modal } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { AppContext } from "services/appContext/AppContext";
import { FeedBackInfoDto } from "services/apis/types/user/FeedBackInfoDto";

type Props = {
    closeModal: () => void;
    onCompleteForm: () => void;
    showLoadingIndicator: boolean;
    feedBackInfoData: FeedBackInfoDto | undefined;
}

const FORM_URL = "https://forms.gle/gwz7f1pGtvcnM2S37";

export default function ClientEngagementModal(props: Props) {
  const { appContext } = useContext(AppContext);
  const theme = appContext.theme;
  const { topHeader, topTitle, body, formUrl } = props.feedBackInfoData || {};

  const handleCompleteForm = () => {
    if (formUrl) {
      window.open(formUrl, '_blank');
    }
    props.onCompleteForm();
  };

  const handleRemindLater = () => {
    props.closeModal();
  };

  return (
    <Modal className="pc-modal-sm modal-dialog-centered" isOpen={true}>
      <div className="modal-header">
        <h5 className="modal-title">
          {topHeader}
        </h5>
      </div>
      <div className="modal-body text-center">
        <h3 className="font-weight-bold mb-3">
          {topTitle}
        </h3>
        <p>
          {body}
        </p>
      </div>
      <div className="modal-footer">
        <Button
          color="link"
          type="button"
          className={`${theme === "light" ? "lblue-color" : ""}`}
          onClick={handleRemindLater}>
          <FormattedMessage id="clientEngagementPreference.remindMeLater"/>
          {props.showLoadingIndicator && <i className="fas fa-spinner fa-spin mr-2" />}
        </Button>
        <Button
          color="primary"
          type="button"
          className={`ml-auto ${theme === "light" ? "bg-lblue no-border" : ""}`}
          onClick={handleCompleteForm}>
          <FormattedMessage id="clientEngagementPreference.completeForm"/>
        </Button>
      </div>
    </Modal>
  );
}